var Publication = {
  init: function () {
    jQuery('<span class="toc-toggle">Show table of contents</span>').insertAfter(".publication-footer header h3");

    jQuery(".toc-toggle").on("click", function () {
      jQuery(".publication-footer details.summary").slideToggle("slow");

      var text = jQuery(this).text() == "Show table of contents" ? "Hide table of contents" : "Show table of contents";
      jQuery(this).text(text).toggleClass("active");
    });
  },
};

jQuery(document).ready(Publication.init);
